/**
 * Catálogo de informes del hub: metadatos de UI y handler.
 * La lista clicable está en reportHub-page.html; aquí solo se resuelve la definición por reportId.
 */

const REPORT_DEFINITIONS = [
  // —— Customer ——
  {
    id: "account-receivable-one",
    handler: "customer",
    label: "Accounts receivable — one customer",
    needsAutocomplete: true,
    autocompleteEntity: "customer",
    autoPrintWithoutUI: false,
    filterDateRange: true,
    filterYear: true,
    allowSheet: true,
  },
  {
    id: "account-receivable-all",
    handler: "customer",
    label: "Accounts receivable — all customers",
    needsAutocomplete: false,
    autoPrintWithoutUI: true,
    filterDateRange: true,
    filterYear: true,
    allowSheet: true,
  },
  {
    id: "customer-profit-all",
    handler: "customer",
    label: "Customer profit — all customers",
    needsAutocomplete: false,
    autoPrintWithoutUI: true,
    filterDateRange: false,
    filterYear: false,
    allowSheet: true,
  },
  {
    id: "customer-profit-one",
    handler: "customer",
    label: "Customer profit — one customer",
    needsAutocomplete: true,
    autocompleteEntity: "customer",
    autoPrintWithoutUI: false,
    filterDateRange: true,
    filterYear: true,
    allowSheet: true,
  },

  // —— Provider ——
  {
    id: "account-payable-one",
    handler: "provider",
    label: "Accounts payable — one provider",
    needsAutocomplete: true,
    autocompleteEntity: "provider",
    autoPrintWithoutUI: false,
    filterDateRange: true,
    filterYear: true,
    allowSheet: true,
  },
  {
    id: "account-payable-all",
    handler: "provider",
    label: "Accounts payable — all providers",
    needsAutocomplete: false,
    autoPrintWithoutUI: true,
    filterDateRange: true,
    filterYear: true,
    allowSheet: true,
  },
  {
    id: "provider-profit-all",
    handler: "provider",
    label: "Provider profit — all providers",
    needsAutocomplete: false,
    autoPrintWithoutUI: true,
    filterDateRange: false,
    filterYear: false,
    allowSheet: true,
  },
  {
    id: "provider-profit-one",
    handler: "provider",
    label: "Provider profit — one provider",
    needsAutocomplete: true,
    autocompleteEntity: "provider",
    autoPrintWithoutUI: false,
    filterDateRange: true,
    filterYear: true,
    allowSheet: true,
  },

  // —— Purchase ——
  {
    id: "purchase-status",
    handler: "purchase",
    label: "Purchase — status report",
    needsAutocomplete: true,
    autocompleteEntity: "purchase",
    autoPrintWithoutUI: false,
    filterDateRange: true,
    filterYear: true,
    allowSheet: true,
  },
  {
    id: "purchase-invoice-pdf",
    handler: "purchase",
    label: "Purchase — invoice (PDF)",
    needsAutocomplete: true,
    autocompleteEntity: "purchase",
    autoPrintWithoutUI: false,
    filterDateRange: true,
    filterYear: true,
    allowSheet: false,
  },

  // —— Sale ——
  {
    id: "sale-invoice-pdf",
    handler: "sale",
    label: "Sale — invoice (PDF)",
    needsAutocomplete: true,
    autocompleteEntity: "sale",
    autoPrintWithoutUI: false,
    filterDateRange: true,
    filterYear: true,
    allowSheet: false,
  },
  {
    id: "sale-pack-slip-pdf",
    handler: "sale",
    label: "Sale — packing slip (PDF)",
    needsAutocomplete: true,
    autocompleteEntity: "sale",
    autoPrintWithoutUI: false,
    filterDateRange: true,
    filterYear: true,
    allowSheet: false,
  },

  // —— Inventory ——
  {
    id: "inventory-items-available",
    handler: "inventory",
    label: "Inventory — items available",
    needsAutocomplete: false,
    autoPrintWithoutUI: true,
    filterDateRange: false,
    filterYear: false,
    allowSheet: true,
  },

  // —— Transaction ——
  {
    id: "transaction-payable-one",
    handler: "transaction",
    label: "Transaction — accounts payable (one)",
    needsAutocomplete: true,
    autocompleteEntity: "transaction",
    autoPrintWithoutUI: false,
    filterDateRange: true,
    filterYear: true,
    allowSheet: true,
  },
  {
    id: "transaction-payable-all",
    handler: "transaction",
    label: "Transaction — accounts payable (all)",
    needsAutocomplete: false,
    autoPrintWithoutUI: true,
    filterDateRange: false,
    filterYear: false,
    allowSheet: true,
  },
];

export function getReportDefinition(reportId) {
  return REPORT_DEFINITIONS.find((r) => r.id === reportId);
}

export function getAllReportDefinitions() {
  return REPORT_DEFINITIONS.slice();
}
